const e = (e2) => new Promise((t2, a2) => {
  const r = new Image(), n = new FileReader();
  n.onload = (e3) => {
    var _a;
    r.src = (_a = e3.target) == null ? void 0 : _a.result, r.onload = () => {
      const e4 = document.createElement("canvas"), a3 = e4.getContext("2d");
      e4.width = r.width, e4.height = r.height, a3.drawImage(r, 0, 0), t2(e4.toDataURL("image/webp", 0.8));
    }, r.onerror = a2;
  }, n.onerror = a2, n.readAsDataURL(e2);
}), t = async (e2, t2, a2) => {
  if (e2.startsWith("data:")) {
    const r2 = e2.split(","), n2 = r2[0].match(/:(.*?);/)[1], o = atob(r2[r2.length - 1]);
    let s = o.length;
    const i = new Uint8Array(s);
    for (; s--; ) i[s] = o.charCodeAt(s);
    const c = new File([i], t2, { type: n2 || a2 });
    return Promise.resolve(c);
  }
  const r = await fetch(e2), n = await r.arrayBuffer();
  return new File([n], t2, { type: a2 });
}, a = (e2) => "url" in e2;
export {
  a as isFileLikeObject,
  e as toBase64,
  t as urlToFile
};
//# sourceMappingURL=index.js.map
